import React, { useState } from 'react'
import { observer } from 'mobx-react'
import SelectorsLayout from 'components/Modules/Slots/ScheduleSettings/layouts/SelectorsLayout'
import ContentLayout from 'components/Modules/Slots/ScheduleSettings/layouts/ContentLayout'
import Flex from 'components/UI/Flex/Flex'
import slotsScheduleSettingsStore, {
  ActionType,
} from 'Stores/slotsScheduleSettingsStore'
import styles from './ScheduleSettings.module.scss'
import { translate as loc, dict } from 'Localisation'
import PageHeader from '../../../UI/PageHeader/PageHeader'
import Button from '../../../CRM/UI/components/Button/Button'
import swal from 'sweetalert'

function ScheduleSettings() {
  const { selectedLocation, sendDataToServer, resetData } =
    slotsScheduleSettingsStore
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmitClick = () => {
    setIsLoading(true)
    sendDataToServer(
      ActionType.sendAllDays,
      () => swal('', 'Настройки успешно сохранены', 'success'),
      (message) =>
        swal(message, 'Ошибка сохранения, проверьте все данные', 'warning'),
    )
  }

  return (
    <>
      {/*<ContentHeader title={loc(dict.schedule_settings.setting_the_slot)} />*/}
      <div className={styles.container}>
        <div className={styles.scheduleHeader}>
          <PageHeader title={loc(dict.schedule_settings.setting_the_slot)}>
            <Flex withGap justify='end' md='center'>
              <Button
                onClick={() => resetData()}
                isDisabled={isLoading}
                whiteBtn
                text={'Отменить изменения'}
              />
              <Button
                onClick={handleSubmitClick}
                isDisabled={isLoading}
                text={'Сохранить настройки'}
              />
            </Flex>
          </PageHeader>

          <SelectorsLayout />
        </div>
        <Flex withGap justify='start'>
          {selectedLocation !== null && <ContentLayout />}
        </Flex>
      </div>
    </>
  )
}

export default observer(ScheduleSettings)
